import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudits = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 2,
			height: 33,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 2,
			width: 2,
			height: 25,
			rx: 1,
			transform: "rotate(-90 0 2)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 22,
			width: 2,
			height: 9,
			rx: 1,
			transform: "rotate(-90 3 22)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 27,
			width: 2,
			height: 9,
			rx: 1,
			transform: "rotate(-90 3 27)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 12,
			width: 2,
			height: 19,
			rx: 1,
			transform: "rotate(-90 3 12)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 33,
			width: 2,
			height: 10,
			rx: 1,
			transform: "rotate(-90 0 33)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 7,
			width: 2,
			height: 19,
			rx: 1,
			transform: "rotate(-90 3 7)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 17,
			width: 2,
			height: 19,
			rx: 1,
			transform: "rotate(-90 3 17)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23,
			width: 2,
			height: 12,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 24,
			r: 4.45,
			stroke: "currentColor",
			strokeWidth: 1.1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 27.8772,
			width: 1.36464,
			height: 5.19804,
			rx: .682318,
			transform: "rotate(-40 20 27.8772)",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAudits);
export default ForwardRef;
